/**
 * The desktop console captures, and the words that go with them.
 *
 * Shot from the running app at 1440x810 against a seeded demo club — the same
 * Iron House Fitness that `backend/scripts/seed-demo-club.js` writes and that
 * the phone captures in /shots were taken from. That is why the figures match
 * across the page: ₹67,900 collected and ₹11,650 pending are the same club on
 * a phone and on a monitor, not two sets of invented numbers.
 *
 * Both appearances, like the phone set, so a monitor inside a dark band shows
 * the dark build and one on a light page shows the light build.
 *
 * Files live under /console/{slug}-{light,dark}.{webp,png} at 1800x1012.
 */

export const CONSOLE_SHOTS = [
  {
    slug: "today",
    screen: "Today",
    headline: "The morning view,\non a bigger screen.",
    subline:
      "What is owed, what is lapsing, who is on the floor. One glance instead of four taps.",
    inFrame:
      "Money owed, plans expiring, the month collected, today's ledger and the floor count.",
  },
  {
    slug: "members",
    screen: "Members",
    headline: "The whole list,\nwith room to work.",
    subline:
      "A desk-sized list, the segments down the side, and a member open beside it.",
    inFrame: "The roster with segment filters and live counts.",
  },
  {
    slug: "money",
    screen: "Money",
    headline: "The month,\nbroken down.",
    subline:
      "Collected against pending, split by plan and by method, with the ledger underneath. Export a date range, up to 400 days.",
    inFrame:
      "Collected, pending, expenses and net, where the money comes from, and the payment method split.",
  },
];

/** Where a capture lives. `appearance` is 'light' or 'dark'. */
export function consoleSrc(slug, appearance, ext = "webp") {
  return "/console/" + slug + "-" + appearance + "." + ext;
}

/** Look one up by slug. */
export function consoleShot(slug) {
  return CONSOLE_SHOTS.find((s) => s.slug === slug);
}

/** The intrinsic size of every capture, for the width/height attributes. */
export const CONSOLE_SIZE = { width: 1800, height: 1012 };
